import React from "react";
import AntdSelect, {SelectProps} from 'antd/lib/select';
import {withError} from '@fishx/tracker';

interface FCSelectProps<VT> extends SelectProps<VT>{
  forwardedRef?: any;
}
export const Select: React.FC<FCSelectProps<any>> =(props) => {
  const {forwardedRef, ...rest} = props;
    return (
      <AntdSelect {...rest} ref ={forwardedRef}/>
    )
};
Select.displayName = 'Select'
export default withError(Select,{
  forwardRef: true,
});




// WEBPACK FOOTER //
// ./src/components/select/index.tsx